import { round } from '@amcharts/amcharts4/.internal/core/utils/Time';
import React, { Component } from 'react';

import './css/Modelo.css';

type T_ModeloProductosProps = {
  cultivo: string,
  modelo: string,
  app: App,
  path: string,
}

type T_ModeloProductosState = {
  images: Array<string>,
  valor: Array<string>,
}

const
  logoPrecio2 = require('./css/img/central_fert/dollarIcon4.png')

export default class ModeloProductos extends Component<T_ModeloProductosProps, T_ModeloProductosState> {
  constructor(props) {
    super(props);

    this.state = {
      dosis: {
        preventiva: [],
        curativa: []
      },
      images: {
        preventiva: [],
        curativa: []
      },
      productos: {
        preventiva: [],
        curativa: []
      },
      valor: [],
      precio: [],
      showPrecio: false,
      volumen: [],
      udVenta: [],
    }
  }

  async componentDidMount() {
    const { cultivo, modelo, app, path } = this.props;

    await fetch('./dosis.json')
      .then(res => res.json())
      .then(data => {
        this.setState({
          productos: {
            preventiva:
              path.includes('BANANO-oscar_rodriguez') ||
              path.includes('BANANO-san_carlos')
                ? data[cultivo][modelo].alternative.productos
                : data[cultivo][modelo].preventiva.productos,
            curativa: data[cultivo][modelo].curativa.productos
          },
          dosis: {
            preventiva:
              path.includes('BANANO-oscar_rodriguez') ||
              path.includes('BANANO-san_carlos')
                ? data[cultivo][modelo].alternative.dosis
                : data[cultivo][modelo].preventiva.dosis,
            curativa: data[cultivo][modelo].curativa.dosis,
          }
        }, () => this.getProductPrecios(this.state.productos));
      })
      .catch(error => console.log(error.toString())
      );
    this.getProductPrecios(this.state.productos)
  }

  getProductPrecios = productos => {
    const { cultivo, modelo, app, path } = this.props;
    const { dosis } = this.state;
    var list = []

    if (this.props.curativa) {
      const imagesCurativa = productos.curativa.map(producto2 => {
        const image = require(`./css/img/tabla_oport/${cultivo}/climasense/${modelo}/curativa/${producto2}.png`);
        return image;
      });

      this.setState({
        images: {
          preventiva: [],
          curativa: imagesCurativa
        }
      });
      let i = 0;
      for (let producto of productos.curativa) {
        let url_week_data = `${app.remote}/get-precio-upl/?session_id=${app.session()}&producto=${producto}`;
        fetch(url_week_data).then(res => res.json()).then(week_data => {
          var prueba = this.state.dosis.curativa[i]
          var regex = /(\d+).(\d+)/g;
          let numeros = []
          if(prueba.match(regex)){numeros = prueba.match(regex)}else{ regex = /(\d+)/g; numeros = prueba.match(regex) }
          var dosisFinal = 0
          if(numeros.length == 1){dosisFinal = numeros[0]}
          else if(numeros[1] == 100){dosisFinal = numeros[0]}else{dosisFinal = numeros[1]}
          const volumenTotal = (this.props.superficie * dosisFinal)
          const cantEnv = (volumenTotal / week_data[0].volumen)
          let venta = Math.ceil(cantEnv / week_data[0].envases)
          let udVenta = 0;
          if (venta == 0) { udVenta = 1} else { udVenta = venta }
          if (venta === Number.POSITIVE_INFINITY) { udVenta = 0}
          let precioTotal = (udVenta * week_data[0].precio)
          if(!precioTotal){precioTotal=0}
          const precioUnitario = (week_data[0].precio)
          const volumen = volumenTotal.toFixed(2)
          this.setState({
            valor: [...this.state.valor, precioTotal],
            precio: [...this.state.precio, precioUnitario],
            volumen: [...this.state.volumen, volumen],
            udVenta: [...this.state.udVenta, udVenta]
          })
          i++;
        });
      }
    } else {
      const imagesPreventiva = productos.preventiva.map(producto2 => {
        const image = require(`./css/img/tabla_oport/${cultivo}/climasense/${modelo}/${
          path.includes('BANANO-oscar_rodriguez') ||
          path.includes('BANANO-san_carlos')
            ? 'alternative'
            : 'preventiva'
        }/${producto2}.png`);
        return image;
      });

      this.setState({
        images: {
          preventiva: imagesPreventiva,
          curativa: []
        }
      });
      let i = 0;
      for (let producto of productos.preventiva) {
        let url_week_data = `${app.remote}/get-precio-upl/?session_id=${app.session()}&producto=${producto}`;
        fetch(url_week_data).then(res => res.json()).then(week_data => {
          var prueba = this.state.dosis.preventiva[i]
          var regex = /(\d+).(\d+)/g;
          let numeros = []
          if(prueba.match(regex)){numeros = prueba.match(regex)}else{ regex = /(\d+)/g; numeros = prueba.match(regex) }
          var dosisFinal = 0
          if(numeros.length == 1){dosisFinal = numeros[0]}
          else if(numeros[1] == 100){dosisFinal = numeros[0]}else{dosisFinal = numeros[1]}
          const volumenTotal = (this.props.superficie * dosisFinal)
          const cantEnv = (volumenTotal / week_data[0].volumen)
          let venta = Math.ceil(cantEnv / week_data[0].envases)
          let udVenta = 0;
          if (venta == 0) { udVenta = 1} else { udVenta = venta }
          if (venta === Number.POSITIVE_INFINITY) { udVenta = 1}
          let precioTotal = (udVenta * week_data[0].precio)
          if(!precioTotal){precioTotal=0}
          const precioUnitario = (week_data[0].precio)
          const volumen = volumenTotal.toFixed(2)
          this.setState({
            valor: [...this.state.valor, precioTotal],
            precio: [...this.state.precio, precioUnitario],
            volumen: [...this.state.volumen, volumen],
            udVenta: [...this.state.udVenta, udVenta]
          })
          i++;
        });

      }
    }
  }

  getProductImages = (productos) => {
    const { cultivo, modelo, app } = this.props;

    const imagesPreventiva = productos.preventiva.map(producto => {
      const image = require(`./css/img/tabla_oport/${cultivo}/climasense/${modelo}/preventiva/${producto}.png`);
      return image;
    });

    const imagesCurativa = productos.curativa.map(producto => {
      const image = require(`./css/img/tabla_oport/${cultivo}/climasense/${modelo}/curativa/${producto}.png`);
      return image;
    });

    this.setState({
      images: {
        preventiva: imagesPreventiva,
        curativa: imagesCurativa
      }
    });
  };

  gen_price = (ev: SyntheticInputEvent<*>): void => {
    if (this.state.showPrecio) {
      this.setState({ showPrecio: false });
    } else {
      this.setState({ showPrecio: true });
    }

  }

  render() {
    const
      { dosis, images, productos, valor, precio, showPrecio, volumen, udVenta } = this.state,
      { preventiva, curativa } = this.props
      ;

    return (
      <div style={{ contain: 'content', margin: '10px' }}>
        {curativa ?
          <div className="model-recomendacion">
            <div className="model-recomendacion-title">
              <p>Aplicación Curativa</p>
              <div className="toolTip" style={{ left: '91%', bottom: '105%', padding: '0px', width: '30px' }}>
                <input type="image" src={logoPrecio2} style={{ width: '100%' }} alt="" onClick={this.gen_price} />
              </div>
            </div>
            <div className="model-recomendacion-productos">
              {images.curativa.map((image, x) =>
                <div key={x} className="modelProd">
                  <img src={image} alt={productos.curativa[x]} className="img-modelProd" />
                  <p>Dosis: {dosis.curativa[x]}</p>
                  {showPrecio &&
                    <div className="model-recomendacion2">
                      <td class="precio">Volumen Total <br></br> {volumen[x]}</td>
                      <hr class="borderline" />
                      <td class="precio">Precio Unitario <br></br> $ {Intl.NumberFormat("en-US").format(precio[x])}</td>
                      <hr class="borderline" />
                      <td class="precio" > Total ({udVenta[x]} Ud) <br></br>  $ {Intl.NumberFormat("en-US").format(valor[x])} <br></br></td>
                    </div>
                  }
                </div>
              )}
            </div>
          </div>
          :
          (preventiva ?
            <div className="model-recomendacion">
              <div className="model-recomendacion-title">
                <p>Aplicación Preventiva</p>
                <div className="toolTip" style={{ left: '91%', bottom: '105%', padding: '0px', width: '30px' }}>
                  <input type="image" src={logoPrecio2} style={{ width: '100%' }} alt="" onClick={this.gen_price} />
                </div>
              </div>
              <div className="model-recomendacion-productos">
                {images.preventiva.length 
                  ? images.preventiva.map((image, x) => (
                    <div key={x} className="modelProd">
                      <img src={image} alt={productos.preventiva[x]} className="img-modelProd" />
                      <p>Dosis: {dosis.preventiva[x]}</p>
                      {showPrecio &&
                        <div className="model-recomendacion2">
                          <td class="precio">Volumen Total<br></br> {volumen[x]}</td>
                          <hr class="borderline" />
                          <td class="precio">Precio Unitario <br></br> $ {Intl.NumberFormat("en-US").format(precio[x])}</td>
                          <hr class="borderline" />
                          <td class="precio"> Total ({udVenta[x]} Ud) <br></br>  $ {Intl.NumberFormat("en-US").format(valor[x])} </td>
                        </div>
                      }
                    </div>
                  ))
                  : (<div style={{marginVertical: '5px'}}><p style={{fontSize: '15px', fontStyle: 'italic'}}>Sin producto</p></div>)
                }
              </div>
            </div>
            :
            null
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ModeloProductos.jsx